import { defineComponent as _defineComponent } from 'vue'
import { useVModel } from '@vueuse/core';
import { computed, ref, unref, watch } from 'vue';

import type { DefaultModalDialogApi } from './bootstrap-modal';
import BootstrapModal from './bootstrap-modal.vue';
import type { ConfirmationFunction } from './confirmation-dialog';
import ProgressBar from './progress-bar.vue';
import { formatPercentage, type ProgressApi, ProgressType } from './progress-dialog';


export default /*#__PURE__*/_defineComponent({
  __name: 'progress-dialog',
  props: {
    modelValue: { type: Boolean },
    percentage: null,
    progressLabel: null,
    progressMessage: null,
    title: null,
    message: null,
    messageClass: null,
    requestCancel: { type: Boolean },
    confirm: null
  },
  emits: ["update:modelValue", "update:percentage", "update:progressLabel", "update:progressMessage", "update:title", "update:message", "update:messageClass", "update:requestCancel", "dialog-closed"],
  setup(__props: any, { expose, emit }: { emit: ({
    (event: 'update:modelValue', value: boolean): void;
    (event: 'update:percentage', value: number): void;
    (event: 'update:progressLabel', value: string): void;
    (event: 'update:progressMessage', value: string): void;
    (event: 'update:title', value: string | undefined): void;
    (event: 'update:message', value: string | undefined): void;
    (event: 'update:messageClass', value: string | undefined): void;
    (event: 'update:requestCancel', value: boolean): void;
    (event: 'dialog-closed', value: undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue?: boolean;
    percentage?: number;
    progressLabel?: string;
    progressMessage?: string;
    title?: string;
    message?: string;
    messageClass?: string;
    requestCancel?: boolean;
    confirm?: ConfirmationFunction;
}


//eslint-disable-next-line no-spaced-func

const showDialog = useVModel(props, 'modelValue', emit, { passive: true });
const percentageModel = useVModel(props, 'percentage', emit, { passive: true });
const progressLabelModel = useVModel(props, 'progressLabel', emit, { passive: true });
const progressMessageModel = useVModel(props, 'progressMessage', emit, { passive: true });
const titleModel = useVModel(props, 'title', emit, { passive: true });
const messageModel = useVModel(props, 'message', emit, { passive: true });
const messageClassModel = useVModel(props, 'messageClass', emit, { passive: true });
const requestCancelModel = useVModel(props, 'requestCancel', emit, { passive: true });
const modalApi = ref<DefaultModalDialogApi | undefined>();

const percentage2 = ref<number | undefined>(undefined);
const progressLabel2 = ref<string | undefined>(undefined);
const progressMessage2 = ref<string | undefined>(undefined);

function formatProgressMessage(percentage: number | undefined, progressMessage: string | undefined) {
    if(progressMessage !== undefined) {
        return progressMessage;
    }
    return formatPercentage(percentage);
}

const progressApi: ProgressApi = {
    toggleModal(show) {
        if(show) {
            requestCancelModel.value = false;
        }
        return unref(modalApi)?.toggleModal(show) ?? Promise.resolve();
    },
    setProgress(percentage, progressMessage, type) {
        switch(type) {
            case ProgressType.SECONDARY:
                percentage2.value = percentage;
                progressMessage2.value = formatProgressMessage(percentage, progressMessage);
                break;
            case ProgressType.MAIN:
            default:
                percentageModel.value = percentage;
                progressMessageModel.value = formatProgressMessage(percentage, progressMessage);
                break;
        }
    },
    setProgressLabel(progressLabel, type) {
        switch(type) {
            case ProgressType.SECONDARY:
                progressLabel2.value = progressLabel;
                break;
            case ProgressType.MAIN:
            default:
                progressLabelModel.value = progressLabel;
                break;
        }
    },
    setTitle(_title: string | undefined) {
        titleModel.value = _title;
    },
    setMessage(_message: string | undefined, _messageClass?: string) {
        messageModel.value = _message;
        if(_messageClass !== undefined) {
            messageClassModel.value = _messageClass;
        }
    },
    isCancelled: computed(() => !!unref(requestCancelModel)),
};
expose(progressApi);

function tryCancel() {
    Promise.resolve()
        .then(() => {
            if(props.confirm) {
                return props.confirm('Confermi?', { cancel: true });
            }
            return Promise.resolve();
        })
        .then(() => {
            requestCancelModel.value = true;
        });
}
watch(showDialog, (val, old) => {
    if(val && !old) {
        requestCancelModel.value = false;
    }
}, { immediate: true });

return { __sfc: true,props, emit, showDialog, percentageModel, progressLabelModel, progressMessageModel, titleModel, messageModel, messageClassModel, requestCancelModel, modalApi, percentage2, progressLabel2, progressMessage2, formatProgressMessage, progressApi, tryCancel, BootstrapModal, ProgressBar }
}

})